import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_2 = { class: "card-body border-top p-9" }
const _hoisted_3 = { class: "row mb-6" }
const _hoisted_4 = { class: "col-lg-6 fv-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama Sekolah", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Field, {
              type: "text",
              name: "name",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detail.name) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ], 2))
}